



















































import Vue from 'vue';
import { CloseFullscreenWrapper, TriggerRefreshError } from '@/mixins';
import {
  FullscreenWrapper,
  FullscreenContent,
  FullscreenSuccess,
  FullscreenError,
  FullscreenLoading,
} from '@/components/fullscreen-wrapper-components';
import { ExtendMixins } from '@/services';
import { MemberBankAccountResponseModel } from '@/@types/member';

interface Data {
  isLoading: boolean;
  showSuccessMessage: boolean;
  successMessage: string;
  showErrorMessage: boolean;
  errorMessage: string;
  refreshError: boolean;
}

export default ExtendMixins(
  CloseFullscreenWrapper,
  TriggerRefreshError,
).extend({
  name: 'RemoveBankAccount',
  props: {
    params: {
      type: Object as () => any,
      required: true,
    },
  },
  data(): Data {
    return {
      isLoading: false,
      showSuccessMessage: false,
      successMessage: this.params.successMessage,
      showErrorMessage: false,
      errorMessage: this.params.errorMessage,
      refreshError: false,
    };
  },
  computed: {
    bankAccounts(): MemberBankAccountResponseModel[] {
      return this.$store.getters.bankAccounts;
    },
    currentBankAccount(): MemberBankAccountResponseModel {
      const accountIndex = this.bankAccounts.findIndex((account) => {
        return account.id.toString() === this.params.bankKey.toString();
      });
      return accountIndex > -1 ? this.bankAccounts[accountIndex] : null;
    },
    contentCallout(): string {
      return `${
        this.currentBankAccount.name
      } (…${this.$options.filters.last4Digits(
        this.currentBankAccount.accountNumber,
      )})`;
    },
  },
  methods: {
    removeBankAccount(): void {
      const payload = {
        bankKey: this.currentBankAccount.id,
        callingApplication: 'Member',
        isTerminated: true,
        useForClaims: false,
        useForContributions: false,
      };
      this.isLoading = true;
      this.$store
        .dispatch('updateBankAccount', payload)
        .then(() => {
          this.refreshBankingInformation();

          // GTM Event - Remove Bank Account
          window.dataLayer.push({
            event: 'deleteBank',
          });
        })
        .catch(() => {
          this.showErrorMessage = true;
          this.isLoading = false;
        });
    },
    refreshBankingInformation(): void {
      this.$store
        .dispatch('getBankingInformation')
        .then(() => {
          this.showSuccessMessage = true;
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
          this.triggerRefreshError({
            message: [
              'remove-bank-account_text_refresh-data-error-message',
              'global_connection-error',
            ],
          });
        });
    },
  },
  components: {
    FullscreenWrapper,
    FullscreenContent,
    FullscreenSuccess,
    FullscreenError,
    FullscreenLoading,
  },
});
